<script setup>
  useSeoMeta({
    robots: () => '',

    title: () => 'Search - Glory Kickboxing',
    description: '',
    canonical: '',

    ogType: 'website',
    ogSiteName: '',
    ogTitle: '',
    ogDescription: '',
    ogImage: '',
    ogUrl: '',

    twitterCard: 'summary_large_image',
    twitterTitle: '',
    twitterDescription: '',
    twitterSite: () => '@GLORY_WS',
  });

</script>

<!----------------------------------------------------------------------------->

<template>
  <div>
    <SearchTemplate></SearchTemplate>
  </div>
</template>

<!----------------------------------------------------------------------------->

<style lang="scss" scoped></style>
